import toast from "react-hot-toast";

import { createAsyncThunk } from "@reduxjs/toolkit";

import type {
  GetClientInvoiceOnboardingStatusPayloadType,
  SingleBomDataPayloadType,
} from "@/redux/invoiceGeneration/invoiceGenrationTypes";

import {
  addInvoiceGenerationApi,
  addOtherInvoiceGenerationApi,
  assignInvoiceColumnsToClientApi,
  deleteInvoiceApi,
  deleteOtherInvoiceApi,
  getAllExpensesInvoicesListApi,
  getAllInvoiceColumnsListApi,
  getAllMappedClientColumnListApi,
  getAllOtherInvoicesListApi,
  getAllRevenueInvoicesListApi,
  getSingleInvoiceDetailsApi,
  getSingleOtherInvoiceDetailsApi,
  updateInvoiceGenerationApi,
  updateOtherInvoiceGenerationApi,
  invoiceGenerationBulkUpload,
  checkDuplicateEntryApi,
  invoiceGenerationGetComment,
  invoiceGenerationPostComment,
  invoiceGenerationApproval,
  copyInvoiceGenerationApi,
  getPaymentPendingApi,
  getAllAllocationListApi,
  invoiceGenerationLockEntryApi,
  getEinvoiceApi,
  getReviewEinvoiceApi,
  eInvoicePostApi,
  eInvoiceCancelApi,
  getInvoiceNotesListApi,
  invoiceGenerationRevenuesBulkUpload,
  invoiceGenerationExpensesBulkUpload,
  sendOverdueEmailApi,
  invoiceGenerationGetCustomerInvoiceDownload,
  getBomListDataApi,
  bomPostApi,
  bomUpdateApi,
  getSingleBomDataApi,
  getBOMSavedTemplateListApi,
  getSingleBomTemplateDataApi,
  uniqueCheckBOMSavedTemplateNameApi,
  getInvoiceHistoryApi,
  getBulkUploadHistoryData,
  getOthersInvoiceHistoryApi,
  invoiceGenerationSuspenseBulkUpload,
  getReviewEWayBillApi,
  getGenerateEWayBillApi,
  eWayBillCancelApi,
  postGenerateEWayBillApi,
  checkDistanceCountApi,
  eInvoiceAuthenticationPostApi,
  eWayBillAuthenticationPostApi,
  invoiceGenerationLockEntryBOMApi,
  postInvoiceOcrApi,
  updateVehicleEWayBillDetailsApi,
  updateTransporterEWayBillDetailsApi,
  getClientColumnAssignedApi,
  getGstr2a2bComparePayloadApi,
  getClientInvoiceOnboardingStatusApi,
  deleteBomEntryApi,
} from "@/apis/invoiceGenerationApis";

import { sendInvoiceGenerationEmailApi } from "@/components/InvoicingAdvance/apis/invoicingAdvance-api";
import { SendInvoiceGenerationEmailPayloadApiType } from "@/components/InvoicingAdvance/apis/invoicingAdvanceApis-type";

import type { GetGstrTwoATwoBComparePayloadType } from "@/commonTypes/gstTypes";
import type {
  AddCommentPayloadType,
  AddInvoiceGenerationPayloadType,
  AddOtherInvoiceGenerationPayloadType,
  ApproveInvoicePayloadType,
  AssignInvoiceColumnsToClientPayloadType,
  DeleteInvoicesListPayloadType,
  DeleteOtherInvoicesListPayloadType,
  DownloadInvoiceGenerationReportsType,
  DownloadOtherInvoicesReportsType,
  DuplicateEntriesPayloadType,
  GetAllExpensesInvoicesListPayloadType,
  GetAllMappedClientColumnsPayloadType,
  GetAllOtherInvoicesListPayloadType,
  GetAllRevenueInvoicesListPayloadType,
  GetAllocationPayloadType,
  GetCommentPayloadType,
  EinvoiceDataPayloadType,
  GetSingleInvoiceDetailsPayloadType,
  GetSingleOtherInvoiceDetailsPayloadType,
  InvoiceNotesPayloadType,
  LockEntryPayloadType,
  PostAllocationPayloadListType,
  UpdateOtherInvoiceGenerationPayloadType,
  EinvoiceRevertDataPayloadType,
  SendOverdueEmailPayloadType,
  BomDataListPayloadType,
  BomDataPayloadType,
  UniqueCheckBomTemplateNamePayloadType,
  InvoiceHistoryPayloadType,
  GetBulkUploadHistoryPayloadType,
  EWayBillDataPayloadType,
  GenerateEWayBillPayloadType,
  EWayBillCancelDataPayloadType,
  ExtendEWayBillPayloadType,
  DistanceCountPayloadType,
  EinvoiceAuthenticationDataPayloadType,
  LockEntryBomPayloadType,
  GetSingleInvoiceDetailsOcrPayloadType,
  UpdateEWayBillPayloadType,
  UpdateTrasporterEWayBillPayloadType,
  GetClientColumnAssignedPayloadType,
  DeleteBomPayloadType,
} from "@/commonTypes/invoiceGenerationTypes";

export const getAllInvoiceColumnsListAction = createAsyncThunk(
  "invoiceGeneration/getAllInvoiceColumns",
  async (token: string) => {
    const response = await getAllInvoiceColumnsListApi(token);
    return response.data;
  }
);

export const getAllMappedClientColumnListAction = createAsyncThunk(
  "invoiceGeneration/getAllMappedClientColumnList",
  async (data: GetAllMappedClientColumnsPayloadType) => {
    const response = await getAllMappedClientColumnListApi(data);
    return response.data;
  }
);

export const getBulkUploadHistoryAction = createAsyncThunk(
  "invoiceGeneration/bulkUploadHistory",
  async (data: GetBulkUploadHistoryPayloadType) => {
    const response = await getBulkUploadHistoryData(data);
    return response.data;
  }
);

export const assignInvoiceColumnsToClientAction = createAsyncThunk(
  "invoiceGeneration/assignInvoiceColumnsToClient",
  async (data: AssignInvoiceColumnsToClientPayloadType) => {
    const response = await assignInvoiceColumnsToClientApi(data);
    return response.data;
  }
);

export const addInvoiceGenerationAction = createAsyncThunk(
  "invoiceGeneration/addInvoice",
  async (data: AddInvoiceGenerationPayloadType) => {
    const response = await addInvoiceGenerationApi(data);
    return response.data;
  }
);

export const copyInvoiceGenerationAction = createAsyncThunk(
  "invoiceGeneration/copyInvoice",
  async (data: any) => {
    const response = await copyInvoiceGenerationApi(data);
    return response.data;
  }
);

export const addOtherInvoiceGenerationAction = createAsyncThunk(
  "invoiceGeneration/addOtherInvoice",
  async (data: AddOtherInvoiceGenerationPayloadType) => {
    const response = await addOtherInvoiceGenerationApi(data);
    return response.data;
  }
);

export const updateOtherInvoiceGenerationAction = createAsyncThunk(
  "invoiceGeneration/updateOtherInvoice",
  async (data: UpdateOtherInvoiceGenerationPayloadType) => {
    const response = await updateOtherInvoiceGenerationApi(data);
    return response.data;
  }
);

export const getAllOtherInvoicesListAction = createAsyncThunk(
  "invoiceGeneration/getAllOtherInvoicesList",
  async (data: GetAllOtherInvoicesListPayloadType) => {
    const response = await getAllOtherInvoicesListApi(data);
    return response.data;
  }
);

export const getAllExpensesInvoicesListAction = createAsyncThunk(
  "invoiceGeneration/getAllExpensesInvoicesList",
  async (data: GetAllExpensesInvoicesListPayloadType) => {
    const response = await getAllExpensesInvoicesListApi(data);
    return response.data;
  }
);

export const getAllRevenuInvoicesListAction = createAsyncThunk(
  "invoiceGeneration/getAllRevenueInvoicesList",
  async (data: GetAllRevenueInvoicesListPayloadType) => {
    const response = await getAllRevenueInvoicesListApi(data);
    return response.data;
  }
);

export const getSingleInvoiceDetailsAction = createAsyncThunk(
  "invoiceGeneration/getSingleInvoiceDetails",
  async (data: GetSingleInvoiceDetailsPayloadType) => {
    const response = await getSingleInvoiceDetailsApi(data);
    return response.data;
  }
);

export const postInvoiceOcrAction = createAsyncThunk(
  "invoiceGeneration/getSingleInvoiceDetailsFromOcrAction",
  async (data: GetSingleInvoiceDetailsOcrPayloadType) => {
    const response = await postInvoiceOcrApi(data);
    return response.data;
  }
);

export const updateInvoiceGenerationAction = createAsyncThunk(
  "invoiceGeneration/updateInvoice",
  async (data: any) => {
    const response = await updateInvoiceGenerationApi(data);
    return response.data;
  }
);

export const getSingleOtherInvoiceDetailsAction = createAsyncThunk(
  "invoiceGeneration/getSingleOtherInvoiceDetails",
  async (data: GetSingleOtherInvoiceDetailsPayloadType) => {
    const response = await getSingleOtherInvoiceDetailsApi(data);
    return response.data;
  }
);
export const deleteInvoiceAction = createAsyncThunk(
  `/invoiceGeneration/deleteInvoice`,
  async (data: DeleteInvoicesListPayloadType) => {
    const response = await deleteInvoiceApi(data);
    return response.data;
  }
);

export const deleteOtherInvoiceAction = createAsyncThunk(
  `/invoiceGeneration/deleteOtherInvoice`,
  async (data: DeleteOtherInvoicesListPayloadType) => {
    const response = await deleteOtherInvoiceApi(data);
    return response.data;
  }
);

export const invoiceGenerationBulkUploadAction = createAsyncThunk(
  `invoice-generation/upload/others/invoice`,
  async (data: any) => {
    const response = await invoiceGenerationBulkUpload(data);
    return response;
  }
);

export const invoiceGenerationSuspenseBulkUploadAction = createAsyncThunk(
  `invoice-generation/upload/Suspense/others/invoice`,
  async (data: any) => {
    const response = await invoiceGenerationSuspenseBulkUpload(data);
    return response;
  }
);

export const invoiceGenerationRevenuesBulkUploadAction = createAsyncThunk(
  `invoice-generation/upload/revenues/invoice`,
  async (data: any) => {
    const response = await invoiceGenerationRevenuesBulkUpload(data);
    return response;
  }
);

export const invoiceGenerationExpensesBulkUploadAction = createAsyncThunk(
  `invoice-generation/upload/expenses/invoice`,
  async (data: any) => {
    const response = await invoiceGenerationExpensesBulkUpload(data);
    return response;
  }
);

export const checkDuplicateEntryAction = createAsyncThunk(
  "/invoice-generation/is/duplicate/invoice",
  async (data: DuplicateEntriesPayloadType) => {
    const response = await checkDuplicateEntryApi(data);
    return response.data;
  }
);

export const getInvoiceAllComment = createAsyncThunk(
  "/invoice-generation/customer/invoice/comments",
  async (data: GetCommentPayloadType) => {
    const response = await invoiceGenerationGetComment(data);
    return response.data;
  }
);

export const getInvoiceCustomerInvoiceDownload = createAsyncThunk(
  "/invoice-generation/customer/invoice/download",
  async (data: GetCommentPayloadType) => {
    const response = await invoiceGenerationGetCustomerInvoiceDownload(data);
    return response.data;
  }
);

export const postInvoiceAllComment = createAsyncThunk(
  "/invoice-generation/add/customer/invoice/comments",
  async (data: AddCommentPayloadType) => {
    const response = await invoiceGenerationPostComment(data);
    return response.data;
  }
);

export const approveInvoiceAction = createAsyncThunk(
  `approve/customer/invoice`,
  async (data: ApproveInvoicePayloadType) => {
    const response = await invoiceGenerationApproval(data);
    return response.data;
  }
);

export const getPaymentPendingList = createAsyncThunk(
  "invoice-generation/get/paymentPending/list",
  async (data: GetAllocationPayloadType) => {
    const response = await getPaymentPendingApi(data);
    return response.data;
  }
);

export const getAllAllocationListAction = createAsyncThunk(
  "invoice-generation/get/all/allocation/list",
  async (data: GetAllocationPayloadType) => {
    const response = await getAllAllocationListApi(data);
    return response.data;
  }
);

export const postLockingEntryAction = createAsyncThunk(
  "invoice-generation/post/locking-entry",
  async (data: LockEntryPayloadType) => {
    const response = await invoiceGenerationLockEntryApi(data);
    return response.data;
  }
);

export const getEinvoiceDataAction = createAsyncThunk(
  "invoice-generation/get/e-invoice",
  async (data: EinvoiceDataPayloadType) => {
    const response = await getEinvoiceApi(data);
    return response.data;
  }
);

export const postEinvoiceAuthenticationAction = createAsyncThunk(
  "invoice-generation/post/authentication",
  async (data: EinvoiceAuthenticationDataPayloadType) => {
    const response = await eInvoiceAuthenticationPostApi(data);
    return response.data;
  }
);

export const postEwayBillAuthenticationAction = createAsyncThunk(
  "invoice-generation/post/e-way-bill/authentication",
  async (data: EinvoiceAuthenticationDataPayloadType) => {
    const response = await eWayBillAuthenticationPostApi(data);
    return response.data;
  }
);

export const getReviewEinvoiceDataAction = createAsyncThunk(
  "invoice-generation/review/e-invoice",
  async (data: EinvoiceDataPayloadType) => {
    const response = await getReviewEinvoiceApi(data);
    return response.data;
  }
);
export const updateVehicleEWayBillDetails = createAsyncThunk(
  "invoice-generation/update/e-way-bill",
  async (data: UpdateEWayBillPayloadType) => {
    const response = await updateVehicleEWayBillDetailsApi(data);
    return response.data;
  }
);
export const updateTransporterEWayBillDetails = createAsyncThunk(
  "invoice-generation/update/transporter/e-way-bill",
  async (data: UpdateTrasporterEWayBillPayloadType) => {
    const response = await updateTransporterEWayBillDetailsApi(data);
    return response.data;
  }
);

export const getBomDataAction = createAsyncThunk(
  "invoice-generation/bill-of-material/list",
  async (data: BomDataListPayloadType) => {
    const response = await getBomListDataApi(data);
    return response.data;
  }
);

export const postBomDataAction = createAsyncThunk(
  "invoice-generation/post/bill-Of-material",
  async (data: BomDataPayloadType) => {
    const response = await bomPostApi(data);
    return response.data;
  }
);

export const updateBomDataAction = createAsyncThunk(
  "invoice-generation/update/bill-Of-material",
  async (data: BomDataPayloadType) => {
    const response = await bomUpdateApi(data);
    return response.data;
  }
);

export const postEinvoiceDataAction = createAsyncThunk(
  "invoice-generation/post/e-invoice",
  async (data: EinvoiceDataPayloadType) => {
    const response = await eInvoicePostApi(data);
    return response.data;
  }
);

export const postCancelEinvoiceDataAction = createAsyncThunk(
  "invoice-generation/post/cancel-e-invoice",
  async (data: EinvoiceRevertDataPayloadType) => {
    const response = await eInvoiceCancelApi(data);
    return response.data;
  }
);

export const invoiceNotesListAction = createAsyncThunk(
  "invoice-generation/invoice/notes",
  async (data: InvoiceNotesPayloadType) => {
    const response = await getInvoiceNotesListApi(data);
    return response.data;
  }
);
export const sendOverdueEmailApiAction = createAsyncThunk(
  "invoice-generation/OverdueEmail",
  async (data: SendOverdueEmailPayloadType) => {
    const response = await sendOverdueEmailApi(data);
    return response.data;
  }
);

export const getSingleBomDataAction = createAsyncThunk(
  "invoice-generation/getSingleBomData",
  async (data: SingleBomDataPayloadType) => {
    const response = await getSingleBomDataApi(data);
    return response.data;
  }
);
export const getSingleBomTemplateDataAction = createAsyncThunk(
  "invoice-generation/getSingleBomTemplateData",
  async (data: SingleBomDataPayloadType) => {
    const response = await getSingleBomTemplateDataApi(data);
    return response.data;
  }
);

export const getBOMSavedTemplateListAction = createAsyncThunk(
  "invoice-generation/getBOMSaveAsTemplateData",
  async (data: BomDataListPayloadType) => {
    const response = await getBOMSavedTemplateListApi(data);
    return response.data;
  }
);

export const uniqueCheckBOMSavedTemplateNameAction = createAsyncThunk(
  "invoice-generation/uniqueCheckBOMSavedTemplateNameAction",
  async (data: UniqueCheckBomTemplateNamePayloadType) => {
    const response = await uniqueCheckBOMSavedTemplateNameApi(data);
    return response.data;
  }
);

export const getInvoiceHistoryDataAction = createAsyncThunk(
  "invoice-generation/history/invoice",
  async (data: InvoiceHistoryPayloadType) => {
    const response = await getInvoiceHistoryApi(data);
    return response.data;
  }
);

export const getOthersInvoiceHistoryDataAction = createAsyncThunk(
  "invoice-generation/others/history/invoice",
  async (data: InvoiceHistoryPayloadType) => {
    const response = await getOthersInvoiceHistoryApi(data);
    return response.data;
  }
);

export const getReviewEWayBillDataAction = createAsyncThunk(
  "invoice-generation/review/eway-bill",
  async (data: EWayBillDataPayloadType) => {
    const response = await getReviewEWayBillApi(data);
    return response.data;
  }
);

export const getGenerateEWayBillAction = createAsyncThunk(
  "invoice-generation/generate/eway-bill",
  async (data: GenerateEWayBillPayloadType) => {
    const response = await getGenerateEWayBillApi(data);
    return response.data;
  }
);

export const cancelEWayBillDataAction = createAsyncThunk(
  "invoice-generation/cancel-e-way-bill",
  async (data: EWayBillCancelDataPayloadType) => {
    const response = await eWayBillCancelApi(data);
    return response.data;
  }
);

export const postExtendEWayBillAction = createAsyncThunk(
  "invoice-generation/expend/eway-bill",
  async (data: ExtendEWayBillPayloadType) => {
    const response = await postGenerateEWayBillApi(data);
    return response.data;
  }
);

export const checkDistanceCountAction = createAsyncThunk(
  "invoice/distance",
  async (data: DistanceCountPayloadType) => {
    const response = await checkDistanceCountApi(data);
    return response;
  }
);

export const postLockingEntryBOMAction = createAsyncThunk(
  "invoice-generation/post/locking-entry/bom",
  async (data: LockEntryBomPayloadType) => {
    const response = await invoiceGenerationLockEntryBOMApi(data);
    return response.data;
  }
);

export const getClientColumnAssignedListAction = createAsyncThunk(
  "invoiceGeneration/getClientColumnAssigned",
  async (data: GetClientColumnAssignedPayloadType) => {
    const response = await getClientColumnAssignedApi(data);
    return response.data;
  }
);

export const getGstrTwoATwoBComparePayloadAction = createAsyncThunk(
  "get/add/gstr2a2b/compare/expense/payload",
  async (data: GetGstrTwoATwoBComparePayloadType) => {
    const response = await getGstr2a2bComparePayloadApi(data);
    return response.data;
  }
);

export const getClientInvoiceOnboardingStatusAction = createAsyncThunk(
  "invoiceGeneration/getClientOnboardingStatus",
  async (data: GetClientInvoiceOnboardingStatusPayloadType) => {
    const response = await getClientInvoiceOnboardingStatusApi(data);
    return response.data;
  }
);

export const sendInvoiceGenerationEmailAction = createAsyncThunk(
  "invoice-generation/InvoiceGenerationEmail",
  async (
    data: SendInvoiceGenerationEmailPayloadApiType,
    { rejectWithValue }
  ) => {
    try {
      const response = await sendInvoiceGenerationEmailApi(data);

      if (!response?.data || response.data.success === 0) {
        toast.error(
          "Time difference should be more than 24 hours for same email",
          { duration: 2000 }
        );
        return rejectWithValue(response?.data);
      }

      toast.success("Invoice mail has been sent successfully.", {
        duration: 2000,
      });

      return response.data;
    } catch (error) {
      toast.error("Something went wrong while sending email", {
        duration: 2000,
      });
      return rejectWithValue(error);
    }
  }
);

export const deleteBomEntryAction = createAsyncThunk(
  `invoiceGeneration/deleteBom`,
  async (data: DeleteBomPayloadType) => {
    const response = await deleteBomEntryApi(data);
    return response.data;
  }
);
